export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9750.7e562633.jpg";